import React, { Component } from 'react';
import { Grid, GridCell } from 'rmwc/Grid';
import { connect } from 'react-redux';
import {Button} from 'rmwc/Button';
import { Typography } from 'rmwc/Typography';
import { Link } from 'react-router-dom'
import { Card } from 'rmwc/Card';
import * as api from '../../api/api';

class LearningTaxonomies extends Component{
	constructor(props) {
		super(props)
    	this.state = {
    		data: {
    			taxonomyDetails: []
    		}
    	}
	}

	handleView = (e, taxonomyTypeId, taxonomyName) => {
		e.preventDefault()

		this.props.history.push(`/portal/app/admin/learning_taxonomies/${taxonomyTypeId}/${taxonomyName}`)
	}

	handleResourceView = (e) => {
		e.preventDefault()

		this.props.history.push(`/portal/app/admin/learning_taxonomies/resources`)
	}

	componentDidMount() {
		let data = Object.assign({}, this.state.data)

		let url = 'learning_taxonomy_types'
		return api.getResponse(this.props.user.accessToken, url)
		.then((result) => {
			data.taxonomyDetails = result
			this.setState({data: data})
		})
	}

	render() {
		let individualTaxonomy
		let handleView = this.handleView
		let handleResourceView = this.handleResourceView

		if (this.state.data.taxonomyDetails.length > 0) {
			individualTaxonomy = (
				<Grid>
					{this.state.data.taxonomyDetails.map(function(taxonomy){
						let taxonomyTypeId = taxonomy.id
						let taxonomyName = taxonomy.name
						return (
							<GridCell span = "6" key = {taxonomyTypeId}>
								<Card style={{padding: '7px'}}>
									<Grid className="opportunity-list-item">
										<GridCell span = "10">
											<Typography align="left">{taxonomy.name}</Typography>
										</GridCell>
										<GridCell span = "2">
											<Button dense style={{ width: '80%' }} onClick= {((e) => handleView(e, taxonomyTypeId, taxonomyName))}>View</Button>
										</GridCell>
									</Grid>
								</Card>
							</GridCell>
						)
					})}
					<GridCell span = "6">
						<Card style={{padding: '7px'}}>
							<Grid className="opportunity-list-item">
								<GridCell span = "10">
									<Typography align="left">Resources</Typography>
								</GridCell>
								<GridCell span = "2">
									<Button dense style={{ width: '80%' }} onClick= {((e) => handleResourceView(e))}>View</Button>
								</GridCell>
							</Grid>
						</Card>
					</GridCell>
				</Grid>
			)
		}
		return (
			<div>
				<Grid>
					<GridCell span = "12">
						<Card style={{padding: '25px'}}>
							<Typography use="headline5">Learning Resources - Home</Typography>
						</Card>
					</GridCell>
				</Grid>
				{individualTaxonomy}
			</div>
		)
	}
}


function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(LearningTaxonomies);


// WEBPACK FOOTER //
// ./src/views/learning_resource_admin/LearningTaxonomies.jsx